import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const recentInsights = [
    {
      id: 1,
      title: 'The Hidden Costs of AI Vendor Lock-in: A 2025 Analysis',
      excerpt: 'New research reveals that organizations spend 40% more on AI solutions due to vendor dependency...',
      date: 'Jan 8, 2025',
      readTime: '3 min read'
    },
    {
      id: 2,
      title: 'Open-Source AI Adoption Accelerates in Enterprise',
      excerpt: 'Fortune 500 companies are increasingly choosing open-source AI solutions for strategic advantage...',
      date: 'Jan 5, 2025',
      readTime: '4 min read'
    },
    {
      id: 3,
      title: 'Building Internal AI Capabilities: Lessons from Early Adopters',
      excerpt: 'Case studies from organizations that successfully built internal AI teams and capabilities...',
      date: 'Jan 2, 2025',
      readTime: '5 min read'
    }
  ];

  const handleSubscribe = (e) => {
    e?.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <section className="bg-gradient-to-br from-brand-primary to-brand-secondary rounded-2xl p-8 lg:p-12 text-white mb-12">
      <div className="max-w-4xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Newsletter Signup */}
          <div>
            <div className="mb-6">
              <div className="flex items-center mb-4">
                <div className="p-3 bg-white/20 rounded-lg mr-4">
                  <Icon name="Mail" size={32} className="text-white" />
                </div>
                <div>
                  <h2 className="text-2xl lg:text-3xl font-bold mb-2">
                    Weekly AI Independence Insights
                  </h2>
                  <p className="text-white/90 text-lg">
                    Stay ahead with strategic insights and practical guidance
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <p className="text-white/90 mb-4">
                Join 12,000+ executives and technical leaders who rely on our weekly insights to navigate the AI transformation landscape.
              </p>
              
              <div className="space-y-3 text-sm text-white/80">
                <div className="flex items-center">
                  <Icon name="Check" size={16} className="mr-3 text-brand-accent" />
                  <span>Strategic AI adoption frameworks and methodologies</span>
                </div>
                <div className="flex items-center">
                  <Icon name="Check" size={16} className="mr-3 text-brand-accent" />
                  <span>Open-source tool reviews and implementation guides</span>
                </div>
                <div className="flex items-center">
                  <Icon name="Check" size={16} className="mr-3 text-brand-accent" />
                  <span>Industry analysis and vendor lock-in risk assessments</span>
                </div>
                <div className="flex items-center">
                  <Icon name="Check" size={16} className="mr-3 text-brand-accent" />
                  <span>Exclusive case studies and transformation stories</span>
                </div>
              </div>
            </div>

            {!subscribed ? (
              <form onSubmit={handleSubscribe} className="space-y-4">
                <div>
                  <Input
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e?.target?.value)}
                    required
                    className="bg-white/10 border-white/20 text-white placeholder-white/60 focus:border-white focus:ring-white"
                  />
                </div>
                <Button
                  type="submit"
                  variant="default"
                  fullWidth
                  className="bg-brand-accent hover:bg-brand-accent/90 text-white"
                  iconName="ArrowRight"
                  iconPosition="right"
                >
                  Subscribe to Weekly Insights
                </Button>
                <p className="text-xs text-white/60">
                  No spam. Unsubscribe anytime. Read our privacy policy.
                </p>
              </form>
            ) : (
              <div className="bg-white/10 rounded-lg p-6 text-center">
                <Icon name="CheckCircle" size={48} className="mx-auto mb-4 text-brand-accent" />
                <h3 className="text-xl font-semibold mb-2">Welcome to AI Independence!</h3>
                <p className="text-white/90">
                  Check your email for a confirmation link and your first weekly insight.
                </p>
              </div>
            )}
          </div>

          {/* Right Column - Recent Insights Preview */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">
              Recent Insights Preview
            </h3>
            
            <div className="space-y-4">
              {recentInsights?.map((insight) => (
                <div
                  key={insight?.id}
                  className="bg-white/10 backdrop-blur-sm rounded-lg p-4 hover:bg-white/15 transition-all duration-200 cursor-pointer"
                >
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="font-medium text-white text-sm leading-tight pr-4">
                      {insight?.title}
                    </h4>
                    <Icon name="ExternalLink" size={16} className="text-white/60 flex-shrink-0" />
                  </div>
                  
                  <p className="text-white/80 text-xs mb-3 line-clamp-2">
                    {insight?.excerpt}
                  </p>
                  
                  <div className="flex items-center justify-between text-xs text-white/60">
                    <span>{insight?.date}</span>
                    <span>{insight?.readTime}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 text-center">
              <Button
                variant="ghost"
                className="text-white hover:bg-white/10 border-white/20"
                iconName="Archive"
                iconPosition="left"
              >
                View All Past Issues
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;